import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { CreatePositionState } from '../create-position-state.initial-state';

export const setDegreesReducer: CaseReducer<CreatePositionState, PayloadAction<PositionJobRequirementState[]>> = (state, { payload }) => {
  state.degrees = payload;
};

export const setSuggestedFieldOfStudyReducer : CaseReducer<CreatePositionState, PayloadAction<PositionJobRequirementState[]>> = (state, { payload }) => {
  state.suggestedFieldsOfStudy = payload;
};

export const setUserInputFieldOfStudyReducer : CaseReducer<CreatePositionState, PayloadAction<PositionJobRequirementState[]>> = (state, { payload }) => {
  state.userInputFieldsOfStudy = payload;
};

export const resetEducationFieldsReducer : CaseReducer<CreatePositionState, PayloadAction<undefined>> = (state) => {
  state.userInputFieldsOfStudy = [] as PositionJobRequirementState[];
  state.suggestedFieldsOfStudy = [] as PositionJobRequirementState[];
  state.degrees = [] as PositionJobRequirementState[];
};
